import * as React from 'react';
import useStyles from './use_styles';
import useTableContext from '../table/use_table_context';
import Checkbox from '../checkbox';
import Tooltip from '../tooltip';
import cloneElementEmotion from '../utils/clone_element_emotion';
import { jsx as ___EmotionJSX } from "@emotion/core";
var defaultComponent = 'td';
var TableSelectionCell = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    avatar,
    component: Component = 'td',
    disabled = false,
    isHeadRow = false,
    id,
    onSelect,
    onSelectAll,
    selected = false,
    tooltipContent,
    label,
    type = 'multiSelection'
  } = _ref;
  var {
    loading,
    theme,
    isSinglePage,
    showFilters
  } = useTableContext();
  var isAvatar = type === 'avatar';
  var isBodyCell = Component === defaultComponent;
  var isHeaderCell = Component === 'th';
  var hasTooltip = tooltipContent && !loading && !isHeaderCell;
  var isHighDensity = theme.density === 'high';
  var [showAvatar, setShowAvatar] = React.useState(isAvatar);
  var handleShowAvatar = React.useCallback(show => {
    if (isAvatar) {
      setShowAvatar(show);
    }
  }, [isAvatar]);
  var handleSelect = React.useCallback(e => {
    if (!e.target.checked) {
      handleShowAvatar(true);
    }
    id !== undefined ? onSelect === null || onSelect === void 0 ? void 0 : onSelect(e, id) : onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(e);
  }, [handleShowAvatar, id, onSelect, onSelectAll]);
  var style = useStyles({
    isHeadRow,
    isSinglePage,
    selected,
    showAvatar,
    showFilters,
    theme,
    isAvatar
  });
  var handleBlur = React.useCallback(() => handleShowAvatar(true), [handleShowAvatar]);
  var handleFocus = React.useCallback(() => handleShowAvatar(false), [handleShowAvatar]);
  var checkboxInput = ___EmotionJSX(Checkbox, {
    checked: selected,
    className: "vn-table__checkbox",
    css: style.checkbox,
    disabled: loading || disabled,
    onBlur: handleBlur,
    onChange: handleSelect,
    onFocus: handleFocus,
    "aria-label": label
  });
  var tooltipID = id ? "tooltip_disabled-".concat(id) : undefined;
  var tooltipCheckbox = ___EmotionJSX(Tooltip, {
    content: tooltipContent,
    id: tooltipID,
    placement: "top"
  }, ___EmotionJSX("span", {
    css: style.tooltipSpan
  }, checkboxInput));
  return ___EmotionJSX(Component, {
    css: style.root,
    ref: ref,
    role: isBodyCell || isHeaderCell ? null : 'cell',
    scope: isHeaderCell ? 'col' : null
  }, ___EmotionJSX("span", {
    css: style.flex
  }, isAvatar && showAvatar && avatar && cloneElementEmotion(avatar, {
    className: 'vn-table__avatar',
    css: style.avatar,
    size: isHighDensity ? 28 : 36,
    'aria-label': label
  }), hasTooltip ? tooltipCheckbox : checkboxInput));
});
TableSelectionCell.displayName = 'TableSelectionCell';
export default TableSelectionCell;